export const VIDEO_BASE_PATH = '/community/videos'
